import React from 'react'
import { Box, Typography } from '@mui/material'
import SettingsBox from 'src/Elements/Data/SettingsBox'
import { TextField, NumberField } from 'src/Libs/inputs/formik'
import { MaxChargePowerField } from 'src/Libs/wallboxes/components/form'
import { SingleToggleSettingBox } from 'src/Elements/SystemSettings/forms'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { WallboxConfigurationModel } from 'src/Libs/wallboxes'
import { UnitTypes } from 'src/Libs/types'
import { CommonFieldTitles, CommonFieldNames, CommonFieldLabels } from './consts'
import { useApp } from 'src/Hooks'

interface Props {
  model: WallboxConfigurationModel
  disabled?: boolean
}

const CommonFieldSetEdsn: React.FC<Props> = ({ model, disabled = false }) => {
  const { t } = useCustomTranslation()
  const { isMobile: isDownSm } = useApp()

  return (
    <Box>
      <Typography variant="h2" sx={{ mb: 2 }}>
        {t(CommonFieldTitles.title)}
      </Typography>
      <SettingsBox
        disabled={disabled}
        title={t(CommonFieldTitles.deviceName)}
        suffix={<TextField fullWidth={isDownSm} name={CommonFieldNames.deviceName} label={t(CommonFieldLabels.deviceName)} disabled={disabled} />}
      />
      <SingleToggleSettingBox title={t(CommonFieldTitles.sunModeActive)} name={CommonFieldNames.sunModeActive} disabled={disabled} />

      <SettingsBox
        disabled={disabled}
        title={t(CommonFieldLabels.minChargePower)}
        suffix={
          <NumberField
            fullWidth={isDownSm}
            name={CommonFieldNames.minChargePower}
            label={t(CommonFieldLabels.minChargePower)}
            suffix={UnitTypes.watt}
            disabled={disabled}
            step={1}
          />
        }
      />

      <SettingsBox
        disabled={disabled}
        title={t(CommonFieldTitles.maxChargePowerLimit)}
        gridSizes={{ mdLeft: 6, mdRight: 6, smLeft: 6, smRight: 6 }}
        suffix={<MaxChargePowerField disabled={disabled} />}
      />

      <SettingsBox
        disabled={disabled}
        title={t('systemSettings.wallbox.settings.maxDischargePower')}
        suffix={
          <NumberField
            fullWidth={isDownSm}
            name="maxDischargePower"
            label={t('systemSettings.wallbox.settings.maxDischargePower')}
            suffix={UnitTypes.watt}
            disabled={disabled}
            step={1}
          />
        }
      />
    </Box>
  )
}

export default CommonFieldSetEdsn
